import { useApi } from '@hero/context';
import type { UseFeaturesByOrgIdApi, UseFeaturesMineApi } from './types';
import { useQueryAPI } from '../../utils';

/** Resolved features for the current org (free defaults + plan + addons + overrides). */
export const useFeaturesMineApi: UseFeaturesMineApi = apiConfig => {
  const api = useApi();
  return useQueryAPI({
    entity: 'features',
    apiFn: api.sales.features.getMine,
    query: undefined,
    apiConfig,
  });
};

/** Admin: features for a specific org. */
export const useFeaturesByOrgIdApi: UseFeaturesByOrgIdApi = (orgId, apiConfig) => {
  const api = useApi();
  return useQueryAPI({
    entity: 'features',
    apiFn: api.sales.features.adminGet,
    query: { orgId } as never,
    apiConfig,
    isEnabled: () => !!orgId,
  });
};
